import { VisaType } from '../network/schema/models'
import { VisaTypeInfo } from '../network/schema/models/visa.type'
import { IFormInputData } from '@tokyojob/frontend-core'

export const JapaneseCitizenId = 1034

export interface IVisaTypeProps extends VisaType {}

/**
 * @todo DELETE AND REFERENCE THE ONE IN THE FRONTENT/CORE PACKAGE
 */
export default class VisaTypeEntity implements IFormInputData {
  constructor(private readonly _props: IVisaTypeProps) {}

  get props(): IVisaTypeProps {
    return this._props
  }

  get label(): string {
    return this.name
  }
  get value(): number {
    return this.id
  }
  /**
   * The unique identifier of this visa type.
   */
  get id(): number {
    return this.props.id
  }

  /**
   * Contains the localization of this visa type.
   */
  get i18n(): VisaTypeInfo[] {
    return this.props.i18n
  }

  /**
   * The name of the visa type
   */
  get name(): string {
    if (this._props.i18n.length === 0) return ''
    return this._props.i18n[0].name
  }

  /**
   * The name of the visa type in Kana form.
   */
  get nameKana(): string {
    // TODO: Update this when multilingual support is added
    return ''
  }

  /**
   * Whether a designation paper is required or not.
   */
  get designationPapersRequired(): boolean {
    return this.props.designationPapersRequired
  }

  /**
   * Whether the visa type has residence card or not.
   */
  get hasResidenceCard(): boolean {
    return this.props.hasResidenceCard
  }

  /**
   * Whether the visa type has expiration date or not.
   */
  get hasExpirationDate(): boolean {
    return this.props.hasExpirationDate
  }

  /**
   * The parent of this visa type.
   */
  get parentId(): number | undefined {
    return this.props.parentId
  }

  /**
   * The children of this visa type.
   */
  get children(): VisaTypeEntity[] {
    return this.props.children.map((e) => VisaTypeEntityFactory(e))
  }

  /**
   * Whether the visa type has children entities or not.
   */
  get hasChildren(): boolean {
    return this.children && this.children.length > 0
  }

  /**
   * This checks if this visa type is Japanese Citizen
   * @returns
   */
  get isJapaneseCitizen(): boolean {
    return this.id === JapaneseCitizenId
  }

  /**
   * Gets the first child visa entity that matches the provided id.
   * @param id
   * @returns
   */
  getChildById(id: number): VisaTypeEntity | undefined {
    if (this.hasChildren) {
      return this.children.find((e) => e.id === id)
    }
  }

  /**
   * This checks if the passed visaEntity is the parent of this visa type
   * @param visaEntity
   * @returns
   */
  isParent(visaEntity: VisaTypeEntity): boolean {
    return visaEntity.id === this.parentId
  }
}

export const EmptyVisaTypePropsFactory = (props?: Partial<IVisaTypeProps>): IVisaTypeProps => ({
  id: 0,
  i18n: [],
  designationPapersRequired: false,
  hasExpirationDate: true,
  hasResidenceCard: true,
  children: [],
  ...props
})

export const VisaTypePropsFactory = (props?: Partial<IVisaTypeProps>): IVisaTypeProps => ({
  id: 0,
  i18n: [],
  designationPapersRequired: false,
  hasExpirationDate: true,
  hasResidenceCard: true,
  children: [],
  ...props
})

export const TestVisaTypeFactory = (testId: number): IVisaTypeProps => ({
  id: testId,
  i18n: [],
  designationPapersRequired: false,
  hasExpirationDate: true,
  hasResidenceCard: true,
  children: []
})

export const EmptyVisaTypeEntityFactory = (props?: Partial<IVisaTypeProps>): VisaTypeEntity => {
  return new VisaTypeEntity(EmptyVisaTypePropsFactory(props))
}

export const VisaTypeEntityFactory = (props?: Partial<IVisaTypeProps>): VisaTypeEntity => {
  return new VisaTypeEntity(VisaTypePropsFactory(props))
}
